import * as mutations from './mutation-types'

export default {
  reset ({commit}) {
    commit(mutations.RESET_FORM)
  },
  option_entity ({commit}, entity) {
    commit(mutations.OPTION_ENTITY_SELECTED, {entity})
  },
  option_goal ({commit}, goal) {
    commit(mutations.OPTION_GOAL_SELECTED, {goal})
  },
  options_objectives_services ({commit}, option) {
    commit(mutations.OPTION_OBJECTIVES_SERVICES_SELECTED, {option})
  },
  options_locations ({commit}) {

  },
  option_duration ({commit}, duration) {
    commit(mutations.OPTION_DURATION_SELECTED, {duration})
  },
  get_audience ({commit}, payload) {
    commit(mutations.RECEIVED_AUDIENCE, payload)
  },
  structure ({commit}, structure) {
    commit(mutations.STRUCTURE_CHANGED, structure)
  },
  goLocations ({commit}) {
    commit(mutations.GO_LOCATIONS)
  },
  goDurations ({commit}) {
    commit(mutations.GO_DURATIONS)
  },
  updateCityLocations ({commit}, value) {
    commit(mutations.ON_INPUT_CITIES, {cities: value})
  },
  updateCountryLocations ({commit}, value) {
    commit(mutations.ON_INPUT_COUNTRIES, {countries: value})
  }
}
